import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'gold' | 'track' | 'outline';
  className?: string;
}
const tones: Record<string, string> = {
  gold: 'border-accent/25 bg-accent-soft text-accent',
  track: 'border-accent bg-accent text-white',
  outline: 'border-line bg-card text-muted'
};
export function Pill({
  children,
  tone = 'gold',
  className = ''
}: PillProps) {
  return <span className={`inline-flex items-center rounded-full border px-4 py-1.5 font-sans text-[10px] font-semibold uppercase tracking-[0.2em] ${tones[tone]} ${className}`} data-id="element-180" data-mp="1avtoijir2aek">
      {children}
    </span>;
}